import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AppNavigationProvider } from './contexts/AppNavigationContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { TreeManageMembersRoute } from './components/TreeManageMembersRoute';
import { RouteTracker } from './components/RouteTracker';
import { initializeAnalytics } from './services/analytics';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { VerifyOtpPage } from './pages/VerifyOtpPage';
import { AuthLandingPage } from './pages/AuthLandingPage';
import { TreesPage } from './pages/TreesPage';
import { CanvasPage } from './pages/CanvasPage';
import { SettingsPage } from './pages/SettingsPage';
import { AdminPage } from './pages/AdminPage';
import { MembersPage } from './pages/MembersPage';
import { PublicRedeemInvitePage } from './pages/PublicRedeemInvitePage';
import { PublicTreePage } from './pages/PublicTreePage';
import { PublicTreeAdminPage } from './pages/PublicTreeAdminPage';
import './App.css';

initializeAnalytics();

function App() {
  return (
    <AuthProvider>
      <AppNavigationProvider>
        <BrowserRouter>
          <RouteTracker />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/verify-otp" element={<VerifyOtpPage />} />
            <Route path="/invite/:token" element={<PublicRedeemInvitePage />} />
            <Route path="/public/tree/:token" element={<PublicTreePage />} />
            <Route path="/public/tree/:slug/:token" element={<PublicTreePage />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AuthLandingPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/trees"
              element={
                <ProtectedRoute>
                  <TreesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/canvas/:treeId"
              element={
                <ProtectedRoute>
                  <CanvasPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/tree/:treeId/members"
              element={
                <ProtectedRoute>
                  <TreeManageMembersRoute>
                    <MembersPage />
                  </TreeManageMembersRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/tree/:treeId/public"
              element={
                <ProtectedRoute>
                  <PublicTreeAdminPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute requireAdministrator>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AppNavigationProvider>
    </AuthProvider>
  );
}

export default App;
